var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitaminD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7635 8.81597V22.5002C17.7635 23.6629 16.8209 24.6055 15.6582 24.6055H3.02666C1.86396 24.6055 0.921387 23.6629 0.921387 22.5002V8.81597C0.921387 7.65327 1.86396 6.71069 3.02666 6.71069H4.0793V4.60547H14.6056V6.71074H15.6583C16.8209 6.71074 17.7635 7.65332 17.7635 8.81597Z",
    fill: "#DF2121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34243 24.6055H3.02666C1.86396 24.6055 0.921387 23.6629 0.921387 22.5002V8.81597C0.921387 7.65327 1.86396 6.71069 3.02666 6.71069H4.0793V4.60547H9.34243V24.6055Z",
    fill: "#DF2121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6054 6.71064H4.0791V3.55273H14.6054V6.71064Z",
    fill: "#DF2121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34224 6.71064H4.0791V3.55273H9.34224V6.71064Z",
    fill: "#DF2121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.658 1.44766V3.55293C15.658 4.13428 15.1867 4.60557 14.6053 4.60557H4.079C3.49766 4.60557 3.02637 4.13433 3.02637 3.55293V1.44766C3.02637 0.866309 3.49761 0.39502 4.079 0.39502H14.6053C15.1867 0.39502 15.658 0.866309 15.658 1.44766Z",
    fill: "#F5C108"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.658 1.44766V1.97397H3.02637V1.44766C3.02637 0.866309 3.49761 0.39502 4.079 0.39502H14.6053C15.1867 0.39502 15.658 0.866309 15.658 1.44766Z",
    fill: "#F5C108"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7629 16.7107H0.92085C0.630176 16.7107 0.394531 16.4751 0.394531 16.1844V9.8686C0.394531 9.57793 0.630176 9.34229 0.92085 9.34229H17.7629C18.0536 9.34229 18.2893 9.57793 18.2893 9.8686V16.1844C18.2893 16.4751 18.0537 16.7107 17.7629 16.7107Z",
    fill: "#F5C108"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4476 20.3945H22.7633C23.7807 20.3945 24.6054 21.2193 24.6054 22.2366V22.7629C24.6054 23.7803 23.7807 24.605 22.7633 24.605H16.4476C15.4302 24.605 14.6055 23.7803 14.6055 22.7629V22.2366C14.6055 21.2193 15.4302 20.3945 16.4476 20.3945Z",
    fill: "#F5C108"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7631 20.3945C23.4979 20.3945 24.132 20.8249 24.4277 21.4472C24.132 22.0695 23.4979 22.4998 22.7631 22.4998H16.4473C15.7125 22.4998 15.0784 22.0695 14.7827 21.4472C15.0784 20.8249 15.7125 20.3945 16.4473 20.3945H22.7631Z",
    fill: "#F5C108"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitaminD);
export default __webpack_public_path__ + "static/media/vitaminD.794d8d45dbd32ce2babd842bdd4ec37b.svg";
export { ForwardRef as ReactComponent };